import { TextField, withStyles } from "@material-ui/core";

const TextFieldRtl = () =>
  withStyles({
    root: {
      minHeight: 30,
      // "& label": {
      //     transformOrigin: "top right",
      //     right: 28,
      //     left: "auto" ,
      //     top : -5
      // },
      // "& .MuiFormLabel-filled":{
      //     right: 19,
      //     left: "auto" ,
      //     top : -1
      // },
      // "& .MuiInputLabel-outlined.Mui-focused":{
      //     right: 19,
      //     left: "auto" ,
      //     top : -1
      // },
      // "& legend": {
      //     textAlign: "right"
      // } ,
      // "& .MuiOutlinedInput-root" : {
      //     padding : 7
      // },
      // "& .MuiOutlinedInput-input" : {
      //     padding : 7 ,
      //     lineHeight : 1.5
      // },
      // "& .MuiSelect-icon":{
      //     right : "unset",
      //     left : '10px'
      // },
      // '& .MuiAutocomplete-inputRoot':{
      //     paddingLeft : '65px',
      //     paddingRight : 'unset !important'
      // },
      // '& .MuiAutocomplete-endAdornment':
      //     {
      //         right : 'unset !important',
      //         left : '6px !important'
      //     },
      // '& .MuiAutocomplete-input':
      //     {
      //         paddingLeft: 'unset !important',
      //         paddingRight: '14px !important'
      //     }
    },
  })(TextField);

export default TextFieldRtl;
